import { Input } from "@alme/ui-web/types/input";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";

export default class EmbeddedIvaRequestProcessor {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>): void {
        this._store = store;
    }

    process(input: Input): Input & { parameters: any } {
        let inputParameters: any = {};
        if (input.parameters) {
            inputParameters = input.parameters;
        }

        if (!inputParameters.Context) {
            inputParameters.Context = {};
        }

        const embeddedRoot = document.getElementById(
            this._settings.Window.embeddedRootId
        );
        if (embeddedRoot) {
            inputParameters.Context.embedded = true;
        }
        else {
            inputParameters.Context.embedded = false;
        }


        return Object.assign({}, input, { parameters: inputParameters });
    }
}



// WEBPACK FOOTER //
// ./modules/request-processor-embedded-iva/request-processor-embedded-iva.ts